import styled from "@emotion/styled";

export const StyleImageContainer = styled.div`
  position: relative;
  margin-bottom: 50px;
`;
export const StyleCoverWrapper = styled.div``;

export const StyleProfileWrapper = styled.div`
  position: fixed;
  top: 9%;
  left: 50px;
  z-index: 999;
`;

export const StyleDayWrapper = styled.div<{ selected?: boolean }>`
  width: 15px;
  aspect-ratio: 1/1;
  border-radius: 50%;
  border: 1px solid
    ${(props: any) => (props.selected ? props.orange.orange500 : "#e9e9e9")};
  color: ${(props: any) =>
    props.selected ? props.orange.orange500 : "#4b4b4b"};
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  transition: all 300ms linear;
  cursor: pointer;
  &:hover {
    border: 1px solid ${(props: any) => props.theme.orange.orange500};
    color: ${(props: any) => props.theme.orange.orange500};
  }
`;
